@use "~theme/breakpoints";
@use "~theme/typography";

.alwaysVisible {
  display: inherit;
}

.separator {
  border: 0;
  border-bottom: 1px solid var(--blue-01-at-30);
  margin: {
    left: 24px;
    right: 24px;
    bottom: 24px;
  }

  @include breakpoints.desktop {
    margin: {
      top: 0;
      left: 32px;
      right: 32px;
      bottom: 24px;
    }
  }
}

.section {
  padding: 32px 24px 16px;

  @include breakpoints.desktop {
    padding: 32px;
  }
}

.sectionHeader {
  @include typography.heading4;
  color: var(--blue-01);
  margin: 0 0 16px;
}

.sectionText {
  margin: 0;

  @include breakpoints.desktop {
    margin-bottom: 4px;
  }
}

.agreementSection {
  padding: 0 12px;
}
